module.exports = __webpack_public_path__ + "media/files/privacy_policy_v2-b594be4da8e80580b266aab747531bcf.docx";